import ServiceLink from "../components/ServiceLink";
import Texts from "../utilis/defaults/Text";
import ServiceCode from "../utilis/enums/ServiceCode";
import {Divider} from "antd";

const ServiceList = () => {
    return <>
        <Divider><h3 className="font-bold ">لیست خدمات ۲۲ گانه</h3></Divider>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <ServiceLink name={Texts.replyToInquiry} path={ServiceCode.ReplyToInquiry}/>
            <ServiceLink name={Texts.BillingReview} path={ServiceCode.BillingReview}/>
            <ServiceLink name={Texts.ChangeAccountType} path={ServiceCode.ChangeAccountType}/>
            <ServiceLink name={Texts.ChangeBranchDiameter} path={ServiceCode.ChangeBranchDiameter}/>
            <ServiceLink name={Texts.ChangeSpecifications} path={ServiceCode.ChangeSpecifications}/>
            <ServiceLink name={Texts.ChangeCapacityContractualBranching} path={ServiceCode.ChangeCapacityContractualBranching}/>
            <ServiceLink name={Texts.ChangeUnit} path={ServiceCode.ChangeUnit}/>
            <ServiceLink name={Texts.MeterTest} path={ServiceCode.MeterTest}/>
            <ServiceLink name={Texts.MeterChange} path={ServiceCode.MeterChange}/>
            <ServiceLink name={Texts.DeclareMeterConsumption} path={ServiceCode.DeclareMeterConsumption}/>
            <ServiceLink name={Texts.SaleTankerWater} path={ServiceCode.SaleTankerWater}/>
            <ServiceLink name={Texts.CollectOrMergeBranch} path={ServiceCode.CollectOrMergeBranch}/>
            <ServiceLink name={Texts.TemporaryDisconnectAndConnectBranch} path={ServiceCode.TemporaryDisconnectAndConnectBranch}/>

            <ServiceLink name={Texts.MidTermBill} path={ServiceCode.MidTermBill}/>
            <ServiceLink name={Texts.InstallAdditionalSiphon} path={ServiceCode.InstallAdditionalSiphon}/>
            <ServiceLink name={Texts.MoveMeasuringDevices} path={ServiceCode.MoveMeasuringDevices}/>
            <ServiceLink name={Texts.WasteWaterBranchAssignment} path={ServiceCode.WasteWaterBranchAssignment}/>
            <ServiceLink name={Texts.WaterBranchAssignment} path={ServiceCode.WaterBranchAssignment}/>
            <ServiceLink name={Texts.MeterSeparation} path={ServiceCode.MeterSeparation}/>
        </div>
    </>
}
export default ServiceList;